import { MdDelete } from "react-icons/md";
import { TextArea } from "../Textarea";
import { Input } from "../Input";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Colors } from "@/lib/theme";
import { ButtonAdd } from "@/components/ui/button";
import MenuItem from "./MenuItem";
import { FaCopy, FaSave } from "react-icons/fa";
import MenuItemModal from "./MenuItemModal";
import { cn } from "@/lib/utils";
import { SectionItemProps } from "./menu.props.type";
import { useSectionItem } from "@/hooks/menu/useSectionItem";
import { Loader } from "../Spinner";

const SectionItem = (props: SectionItemProps) => {
  const {
    index,
    register,
    errors,
    control,
    section,
    isOpen,
    handleAccordionChange,
    menuItemOptions,
    getValues,
    setValue,
    isEdit,
    setError,
    menuId,
    appendSection,
    removeSection,
  } = props;

  const {
    isShow,
    openModal,
    close,
    selectedItemIndex,
    menuItemsFields,
    appendMenuItem,
    handleAddEditSection,
    sectionItem,
    sectionErrors,
    openEditModal,
    setSelectedItemIndex,
    isLoadingToAddOrEditSection,
    handleDuplicateSectionItem,
    handleRemoveSectionItem,
    isLoadDupplicateSectionItem,
    isLoadDeleteSectionItem,
    removeMenuItem,
    onSelectSectionImage,
    imageSection,
  } = useSectionItem({
    index,
    control,
    getValues,
    setValue,
    setError,
    isEdit,
    errors,
    section,
    menuId,
    appendSection,
    removeSection,
  });

  return (
    <>
      <Accordion
        type="single"
        collapsible
        value={isOpen ? `menu_section_${index}` : ""}
        className={cn(
          "bg-white w-full border rounded-xl shadow-md  mb-6 px-3 transition-all ease-out duration-500",
          sectionErrors ? "border-danger" : "border-grayLight"
        )}
      >
        <AccordionItem value={`menu_section_${index}`}>
          <div className="flex-1 flex justify-between items-center py-2">
            <div
              className="flex items-center cursor-pointer w-full"
              onClick={() => handleAccordionChange(index)}
            >
              {(section?.image?.url || imageSection) && (
                <img
                  src={imageSection ? imageSection : section?.image?.url}
                  alt="section image"
                  className="w-8 h-8 object-contain mr-3"
                />
              )}
              <h5
                className="text-dark font-medium text-base"
              >
                {sectionItem?.title || "Titre de la section"}
              </h5>
            </div>
            <div className="flex items-center space-x-3">
              {isEdit && (
                <>
                  {isLoadingToAddOrEditSection ? (
                    <Loader border="border-success" />
                  ) : (
                    <button
                      title="Enregistrer"
                      type="button"
                      onClick={() => handleAddEditSection(index, section?.id)}
                      className="bg-success w-6 h-6 rounded-full bg-opacity-20 flex items-center justify-center hover:bg-opacity-30"
                    >
                      <FaSave color={Colors.blue} fontSize={14} />
                    </button>
                  )}
                </>
              )}
              {isLoadDupplicateSectionItem ? (
                <Loader border="border-thblue" />
              ) : (
                <button
                  title="Duppliquer"
                  type="button"
                  onClick={() => handleDuplicateSectionItem(index, section?.id)}
                  className="bg-thblue w-6 h-6 rounded-full bg-opacity-20 flex items-center justify-center hover:bg-opacity-30"
                >
                  <FaCopy color={Colors.blue} fontSize={14} />
                </button>
              )}

              <>
                {isLoadDeleteSectionItem ? (
                  <Loader border="border-danger" />
                ) : (
                  <button
                    type="button"
                    onClick={() => handleRemoveSectionItem(index, section?.id)}
                    className="bg-danger w-6 h-6 rounded-full bg-opacity-20 flex items-center justify-center hover:bg-opacity-30"
                  >
                    <MdDelete color={Colors.danger} fontSize={18} />
                  </button>
                )}
              </>
              <AccordionTrigger
                className="m-0"
                onClick={() => handleAccordionChange(index)}
              />
            </div>
          </div>

          <AccordionContent>
            <div className="mb-12 mt-6">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                <div className="mb-5">
                  <Input
                    label="Titre"
                    type="text"
                    id="name"
                    placeholder="Titre"
                    required
                    {...register(`menuSections.${index}.title`)}
                    error={sectionErrors?.title}
                  />
                </div>
                <div className="mb-5">
                  <Input
                    label="Position"
                    type="number"
                    id="position"
                    required
                    placeholder="Position"
                    {...register(`menuSections.${index}.sortOrder`)}
                    error={sectionErrors?.sortOrder}
                    min={1}
                  />
                </div>
                <div className="mb-5">
                  <Input
                    label="Image"
                    type="file"
                    id="image"
                    placeholder="Lien de l'image"
                    onChange={(e) => onSelectSectionImage(e, index)}
                    error={sectionErrors?.image}
                    accept="image/*"
                  />
                </div>
              </div>

              <div className="mb-5">
                <TextArea
                  label="Description"
                  placeholder="Description  de la section"
                  id="descriptionSection"
                  {...register(`menuSections.${index}.description`)}
                  error={sectionErrors?.description}
                />
              </div>
            </div>

            {/* menuSections list items */}
            <div>
              <div className="flex items-center justify-between mb-8">
                <h5 className="text-dark font-medium text-base">
                  Liste des éléments
                </h5>
                <ButtonAdd
                  label="Ajouter"
                  type="button"
                  onClick={() => {
                    openModal(-1);
                  }}
                />
              </div>

              <div className="overflow-x-auto">
                {menuItemsFields.length > 0 ? (
                  <table className="w-full text-left table-auto">
                    <thead>
                      <tr>
                        <th className="px-4 py-2">Image</th>
                        <th className="px-4 py-2">Nom</th>
                        <th className="px-4 py-2">Prix</th>
                        <th className="px-4 py-2">Position</th>
                        <th className="px-4 py-2 text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {menuItemsFields.map((menuItem, i) => (
                        <tr className="border-b" key={menuItem.id}>
                          <MenuItem
                            sectionIndex={index}
                            menuItemIndex={i}
                            removeMenuItem={removeMenuItem}
                            menuItemsLength={menuItemsFields.length}
                            menuItem={section?.menuItems?.[i]}
                            getValues={getValues}
                            menuItemOptions={menuItemOptions}
                            openEditModal={openEditModal}
                            isEdit={isEdit}
                            appendMenuItem={appendMenuItem}
                          />
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p className="text-center text-gray-500 py-4">
                    Cliquez sur le bouton "Ajouter" pour ajouter un élément à la
                    section
                  </p>
                )}
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      {selectedItemIndex !== null && (
        <MenuItemModal
          appendMenuItem={appendMenuItem}
          sectionIndex={index}
          menuItemIndex={selectedItemIndex}
          menuItemsLength={menuItemsFields.length}
          menuItem={section?.menuItems?.[selectedItemIndex]}
          isOpen={isShow}
          onClose={() => {
            close();
            setSelectedItemIndex(null);
          }}
          menuItemOptions={menuItemOptions}
          getValues={getValues}
          setValues={setValue}
          section={section}
        />
      )}
    </>
  );
};

export default SectionItem;
